export default __webpack_public_path__ + "static/media/PricingToolHeaderBG.313bd469.jpg";